import React from 'react';
import { Layout } from 'antd';
import Sidebar from 'components/Sidebar/Sidebar';
import { RouteRedirect, Routes } from '@unicus/react-ui-kit';
import 'components/IconLibrary';
import InsideHeader from 'components/Topbar/InsideHeader';
import useAuth from 'core/hooks/useAuth';
import useSubscription from 'core/hooks/useSubscription';

const { Content } = Layout;

const PartnershipContainer = (props) => {
  const { match, routes, roles, basePath, restrictRoles = [] } = props;
  const { isAuthenticated, isAdmin, isMultiTenant, tenantId } = useAuth();
  const { isActivated } = useSubscription();

  const onBeforeRouteRender = ({ route }) => {
    if (isAuthenticated && isAdmin() && !tenantId) {
      return <RouteRedirect to="/a" />;
    }

    if (isAuthenticated && isMultiTenant && !tenantId) {
      return <RouteRedirect to="/accounts-chooser" />;
    }

    if (!isAuthenticated) {
      return <RouteRedirect to="/signout" />;
    }

    if (!isActivated && route?.path !== '/subscriptions') {
      return <RouteRedirect to="/p/subscriptions" />;
    }

    return null;
  };

  return (
    <Layout className="gx-app-layout">
      <Sidebar routes={routes} match={match} />
      <Layout>
        <InsideHeader routes={routes} match={match} />
        <Content
          id="main-container"
          className="gx-layout-content gx-container-wrap"
        >
          <div className="gx-main-content-wrapper">
            <Routes
              match={match}
              routes={routes}
              roles={roles}
              basePath={basePath}
              restrictRoles={restrictRoles}
              onBeforeRouteRender={onBeforeRouteRender}
              isContainer
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default PartnershipContainer;
